// jQueryのカスタムメソッドとしてtoggleTextを定義
jQuery.fn.toggleText = function(text1, text2) {
  return this.each(function() {
    var $this = $(this);
    if ($this.text() === text1) $this.text(text2);
    else $this.text(text1);
  });
};

// トグルボタンの実装
$(document).on('turbolinks:load', function () {
  // アカウント編集画面の変更後パスワードフォームのトグル操作
  $('#password-change-form').hide(); // 初期状態では非表示
  $('#password-change-toggle').on('click', function() {
    $(this).next('#password-change-form').slideToggle(200);
    $(this).children('.fa').toggleClass('fa-chevron-down fa-chevron-right');
  });

  // リーグ詳細画面のタイトルトグル
  $('.league-title').on('click', function() {
    $(this).children('.toggle-hidden').slideToggle(200);
    $(this).children('.league-title-value').children('.fa').toggleClass('fa-chevron-down fa-chevron-up');
  });
  // 成績登録フォームのptで記録する留意事項のトグル
  $('#info-pt-record-content').hide(); // 初期状態では非表示
  $('#info-pt-record').on('click', function() {
    $(this).children('ul').slideToggle(300);
    $(this).children('.info-title').children('.fa').toggleClass('fa-chevron-right fa-chevron-down');
  });
});
